import { Module, Mutation, VuexModule, config } from "vuex-module-decorators";
import { IActivity } from "../types";

config.rawError = true;

@Module({ namespaced: true })
export default class SecurityModule extends VuexModule {
  activities: IActivity[] | null = null;

  @Mutation
  setActivities(activities: IActivity[]) {
    this.activities = activities;
  }

  @Mutation
  clear() {
    this.activities = null;
  }
}
